<template>
    <v-container class="max-container">
        <v-row :class="$vuetify.breakpoint.sm || $vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl ? 'flex-col-center' : '' ">
            <v-col class="flex-col-center no-pd" v-if=" shoppingInformationObject.link === '/login' " cols="12">
                <span class="vrow_vcol__title">Parabéns!</span>
                <span class="vrow_vcol__title">Sua compra rendeu {{ shoppingInformationObject.points  + ( shoppingInformationObject.points > 1 ? ' pontos.' : ' ponto.' ) }}</span>
            </v-col>
            <v-col class="flex-row-center no-pd" v-if="shoppingInformationObject.link !== '/login' " cols="12">
                <span class="vrow_vcol__title">Veja o resumo da sua compra</span>
            </v-col>
            <!-- <v-col class="no-pd-l no-pd-r no-pd-b" cols="12">
                <div class="flex-col-center">
                    <strong>100/2000</strong>
                    <div>x%</div>
                    <v-progress-circular size="115" color="#9C22FC" rotate="90" :value="25" width="5" class="client-progress">
                        <div class="flex-col-center">
                            <v-img src="@/assets/points-program/medal_bronze.svg"></v-img>
                            <div>
                                <span class="monetary">R$</span><strong> 1800 </strong>
                            </div>
                            <div class="ranking-bond">OURO</div>
                        </div>
                    </v-progress-circular>
                    <div class="rescue-day">
                        <p>Seus pontos expiram em: X</p>
                        Fulano tem até dia <strong>25/03</strong> para continuar subindo de nível
                    </div>
                </div>
            </v-col> -->
            <v-col class="flex-row-center no-pd" cols="12" v-if="shoppingInformationObject.link === '/login' && shoppingInformationObject.pointsExpiringDate">
                <span class="vrow_vcol__subtitle">{{ shoppingInformationObject.points  + ( shoppingInformationObject.points > 1 ? ' pontos' : ' ponto' ) }} expiram em: </span>
                <strong>{{shoppingInformationObject.pointsExpiringDate}}</strong>
            </v-col>

            <v-col class="no-pd-r no-pd-l" cols="12" sm="11" md="6">
                <v-card elevation="4">
                    <v-card-text class="flex-col-start no-pd">

                        <v-col class="flex-row-space-around align-center" v-for="(product, index) in shoppingInformationObject.items" :key="index">
                            <div class="flex-row-start">
                                <v-img v-if="product.image" class="vrow_vcol_card_cardtext__img" :src="product.image"/>
                                <v-img v-if="!product.image" class="vrow_vcol_card_cardtext__img" src="@/assets/empty_produto.svg"/>
                                <span style="margin-right:6px ;">{{'('+product.quantity+'x)'}}</span>
                                <span class="vrow_vcol_card_cardtext__productname text-truncate">{{product.name}}</span>                               
                            </div>                            
                            <span class="vrow_vcol_card_cardtext__productname--value">{{ product.total | currency(product.total) }}</span>
                        </v-col>

                        <v-col class="no-pd-t no-pd-b">
                            <v-divider/>
                        </v-col>

                        <v-col class="flex-row-start justify-space-between">
                            <span class="vrow_vcol_card_cardtext__fullvalue">Total</span>
                            <span class="vrow_vcol_card_cardtext__fullvalue--value">{{shoppingInformationObject.total | currency(shoppingInformationObject.total)}}</span>
                        </v-col>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col class="flex-row-center" cols="12" v-if=" shoppingInformationObject.link !== '/inicio' ">
                <span class="vrow_vcol_subtitle--secondary">{{ shoppingInformationObject.link === '/login' ? 'Continue juntando pontos para trocar em prêmios!' : 'Cadastre-se para juntar pontos e trocar em prêmios!' }}</span>
            </v-col>
            <v-col class="no-pd-r no-pd-l" cols="12" sm="11" md="6" v-if=" shoppingInformationObject.link !== '/inicio' ">
                <v-btn class="vrow_vcol__btn text-none" style="width:100%;" :color="currentCompany.primaryColor" @click="goToRoute(shoppingInformationObject.link)">
                    <span style="color: white"> {{ shoppingInformationObject.link === '/login' ? 'Entrar' : 'Cadastrar'}}</span>
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
//Store
import { mapGetters } from "vuex";

export default {
    name: 'shoppingDetail',
    props: {
        shoppingInformationObject: {
            type: Object
        }
    },
    computed: {
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        ),
    },
    data: () => ({
    }),
    created() {

    },
    watch: {
        shoppingInformationObject: {
            deep: true,
            handler() {
                this.shoppingInformationObject.pointsExpiringDate = this.getDateByTimeStamp(this.shoppingInformationObject.pointsExpiringDate)
            }
        }
    },
    methods: {
        getDateByTimeStamp( data ){
            if( data !== null && data !== undefined ) {
                var moment = require('moment')
                var formatted =  moment(data).format("DD/MM/YYYY")
                return formatted;
            }            
        },
        goToRoute(route) {
            if(route !== null && route !== undefined) {
                this.$router.push( {path: route} )
            }
        },
        getDateByTimeStamp( data ){
            if( data !== null && data !== undefined && data !== undefined ) {
                var moment = require('moment')
                var formatted =  moment(data).format("DD/MM/YYYY")
                return formatted;
            } else return '-' 
        }
    }
}
</script>

<style scoped>
.vrow_vcol__title {
    font-weight: 900;
    font-size: 18px;
}
.vrow_vcol__subtitle {
    font-weight: 600;
    font-size: 16px;
    margin-right: 6px;
}
.vrow_vcol_card_cardtext__img {
    max-height: 30px;
    max-width: 30px;
    margin-right: 10px;
}
.vrow_vcol_card_cardtext__productname {
    color: var(--cor--cinza--escuro);
    font-size: 14px;
    font-weight: 600;
    max-width: 150px;
}
.vrow_vcol_card_cardtext__productname--value {
    color: var(--cor--cinza--escuro);
    font-size: 14px;
    font-weight: 700;
}
.vrow_vcol_card_cardtext__fullvalue {
    color: var(--cor--preta);
    font-size: 14px;
    font-weight: 800;
}
.vrow_vcol_card_cardtext__fullvalue--value {
    color: var(--cor--roxo);
    font-size: 14px;
    font-weight: 700;
}
.vrow_vcol_subtitle--secondary {
    font-weight: 800;
    font-size: 14px;
}
.vrow_vcol__btn {
    padding: 20px 34px !important;
    height: 40px !important;
}
.rescue-day{
    text-align: center;
    margin-top: 10px;
    font-size: 13px;
    width: 80%;
}
.client-progress{
    margin: 10px;
}
.monetary{
    font-size: 10px;
}
</style>